import  {useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';
import { FaFileAudio, FaFilePdf, FaFileWord, FaFilePowerpoint, FaFileAlt, FaCode } from "react-icons/fa";
import CoursePreviewModal from './courseContent/CoursePreviewModal';
import DeleteCMLModal from './courseContent/DeleteCMLModal';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const TeacherCourseDetail = () => {
  const { id } = useParams();
  const navigate=useNavigate()
  const [course, setCourse] = useState(null);
  const [error, setError] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [preview,setPreview]=useState(null)
  const [openResources,setOpenResources]=useState(null)
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await fetch(`${BASE_URL}/courses/${id}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setCourse(data);
      } catch (err) {
        setError(err.message);
      }
    };

    if (id) {
      fetchCourse();
    }
  }, [id]);
 
const getLessonIcon = (type,file) => {
  switch (type) {
    case "video":
      return <FaPlay className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)} />;
    case "audio":
      return <FaFileAudio className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "pdf":
      return <FaFilePdf className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "doc":
      return <FaFileWord className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "ppt":
      return <FaFilePowerpoint className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "txt":
      return <FaFileAlt className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "code":
      return <FaCode className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    default:
      return <FaFileAlt className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>; // fallback
  }
};
  if (error) return <div>Error: {error}</div>;
  if (!course) return <div>Loading...</div>;
  return (
<div className="p-2 py-6 md:px-6 min-h-screen bg-gray-50 font-sans">
  {/* Course Header */}
  <div className="mb-6 bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">

    {/* Title and Actions */}
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900">{course.name}</h1>
      </div>

      <div className="flex gap-3">
        <button
          onClick={() => navigate(`/teacher/course/edit/${course.id}`)}
          className="flex items-center gap-2 px-4 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Edit Course
        </button>

        <button
          onClick={() => setDeleteId(course.id)}
          className="flex items-center gap-2 px-4 py-2.5 bg-red-500 text-white text-sm font-medium rounded-xl hover:bg-red-600 transition-colors"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Delete Course
        </button>
      </div>
    </div>

    {/* Meta Grid */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200">
        <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l5 5a2 2 0 01.586 1.414V19a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z" />
          </svg>
        </div>
        <div>
          <p className="text-xs text-gray-500">Category</p>
          <p className="text-sm font-medium text-gray-900">{course.category_name} › {course.subcategory_name}</p>
        </div>
      </div>

      <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200">
        <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <p className="text-xs text-gray-500">Price</p>
          <p className={`text-sm font-medium ${course.type === "Free" ? "text-green-600" : "text-amber-600"}`}>
            {course.type === "Paid" ? `$${course.price}` : "Free"}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200">
        <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
          <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <p className="text-xs text-gray-500">Last Updated</p>
          <p className="text-sm font-medium text-gray-900">{course.updated_at}</p>
        </div>
      </div>
    </div>

    {/* Description */}
    <div className="p-4 bg-gray-50 rounded-xl border-l-4 border-[#0f6abf]">
      <p className="text-sm text-gray-700 leading-relaxed">{course.description}</p>
    </div>

  </div>

  {/* Modules Section */}
  <div className="bg-white rounded-2xl border border-gray-200 shadow-sm">

    {/* Modules Header */}
    <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gray-50">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
          <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-gray-900">Course Modules</h2>
      </div>
      <span className="px-3 py-1 bg-white border border-gray-300 text-xs font-medium rounded-lg text-gray-700">
        {course.modules.length} modules
      </span>
    </div>

    {/* Modules List */}
    {course.modules.map((module, index) => (
      <div key={index} className="border-b border-gray-200 last:border-none p-6 hover:bg-gray-50/50 transition">

        {/* Module Header */}
        <div className="mb-4">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-base font-semibold text-gray-900">
              Module {index + 1}: {module.title}
            </h3>
          </div>
          <p className="text-sm text-gray-600 mb-3">{module.description}</p>
          <div className="flex gap-4 text-xs text-gray-500">
            <span className="flex items-center gap-1.5">
              <svg className="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              {module.lessons.length} lessons
            </span>
            <span className="flex items-center gap-1.5">
              <svg className="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {module.totalDuration}
            </span>
          </div>
        </div>

        {/* Lessons */}
        <div className="space-y-2 pl-6">
          {module.lessons.map((lesson, idx) => (
            <div
              key={idx}
              className="p-4 bg-gray-50 rounded-xl border border-gray-200 hover:border-[#0f6abf]/30 hover:shadow-sm transition"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                    {getLessonIcon(lesson.type, lesson.content_file)}
                  </div>
                  <span className="text-sm font-medium text-gray-900">{lesson.title}</span>
                </div>

                {lesson.resources?.length > 0 && (
                  <button
                    onClick={() => setOpenResources(v => v === lesson.id ? null : lesson.id)}
                    className="px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors"
                  >
                    {openResources === lesson.id ? 'Hide' : 'Show'} resources
                  </button>
                )}
              </div>

              {/* Resources */}
              {lesson.resources?.length > 0 && openResources === lesson.id && (
                <div className="mt-3 pt-3 border-t border-gray-200">
                  <div className="space-y-2">
                    {lesson.resources.map((resource, i) => (
                      <a
                        key={i}
                        href={resource.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#0f6abf] transition-colors"
                      >
                        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <span>{resource.file.split("/").pop()}</span>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    ))}
  </div>

  <DeleteCMLModal deleteId={deleteId} setDeleteId={setDeleteId} type="course" />

  {preview !== null && (
    <CoursePreviewModal file={preview} setPreview={setPreview} />
  )}

</div>

  );
};

export default TeacherCourseDetail;